import {defineStore} from 'pinia'

export const useCurrencyStore = defineStore('currency', () => {
    const currency = ref(useRuntimeConfig().public.currency ?? 'SEK')
    return {currency}
})
